var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('text-bubble');
import { breakpoints, theme } from '@shapeable/theme';
export var TextBubbleDefaultProps = {
  size: 80
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-weight: 500;\n    background: ", ";\n    color: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: border-color 0.3s;\n\n    ", "\n\n    ", "\n\n    ", "\n    \n    ", "\n\n  "], ["\n    font-weight: 500;\n    background: ", ";\n    color: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: border-color 0.3s;\n\n    ", "\n\n    ", "\n\n    ", "\n    \n    ", "\n\n  "])), theme.COLOR('dark'), theme.COLOR('light'), function (props) {
    return props.onClick && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      cursor: pointer;\n    "], ["\n      cursor: pointer;\n    "])));
  }, function (props) {
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n       width: ", ";\n       height: ", ";\n    "], ["\n       width: ", ";\n       height: ", ";\n    "])), props.size && props.size + "px" || '100%', props.size && props.size + "px" || '100%');
  }, function (props) {
    return props.size && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), theme.FONT_SIZE(Math.floor(0.4 * props.size)));
  }, function (props) {
    return props._link && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      &:hover {\n        border-color: ", ";\n      }\n    "], ["\n      &:hover {\n        border-color: ", ";\n      }\n    "])), theme.COLOR('link'));
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var TextBubble = function TextBubble(props) {
  var className = props.className,
      children = props.children,
      size = props.size,
      onClick = props.onClick;
  return React.createElement(My.Container, {
    onClick: onClick,
    size: size,
    className: cls.name(className)
  }, children);
};
TextBubble.defaultProps = TextBubbleDefaultProps;
TextBubble.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;